/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findAddOnsAndContent = () => (
    gql`query findAddonsAndContent (
        $brand: String!
        $locale: String!
        $environment: String!
        $zipCode: String!
        $deliveryDate: String!
        $categoryId: String!
        $productBaseCode: String!
        $productSku: String!
        $query: String!
    ) {
        findAddonsAndContent (
            brand: $brand
            locale: $locale
            environment: $environment
            zipCode: $zipCode
            deliveryDate: $deliveryDate
            categoryId: $categoryId
            productBaseCode: $productBaseCode
            productSku: $productSku
            query: $query
        ) {
            content
            addonGroups {
                id
                name
                title
                image {
                    name
                }
                addons {
                    id
                    brandId
                    name
                    partNumber
                    ageVerifyFlag
                    legacyId
                    image {
                        name
                        path
                    }
                    prices {
                        type
                        value
                    }
                }
                price {
                    retail {
                        from
                        to 
                        __typename
                    }
                    sale { 
                        from
                        to 
                        __typename
                    } 
                    __typename
                }
                maxAllowedAddons
                sequence
            }
        }
    }`
);

export default findAddOnsAndContent;
